import React from 'react'
import { Bar } from '@nivo/bar'
import cn from 'classnames'
import compact from 'lodash/compact'

import ArrowTop from 'app/components/SVGS/ArrowTop'
import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'
import { COLORS_BY_REVIEWER_TYPE, COLORS_OPACITY_08, DIRECT, PEERS, SELF, SUPERVISORS } from '../Reports'
import { NA } from '../constants'

import './styles.scss'

export const bc = 'bar-chart'

const FIRST_ROW = 'avg'

const styleMap = isBoldBar => ({
  2: {
    barHeight: isBoldBar ? 165 : 160,
    axiosHeight: isBoldBar ? '70px' : '65px',
  },
  3: {
    barHeight: isBoldBar ? 210 : 200,
    axiosHeight: isBoldBar ? '110px' : '105px',
  },
  4: {
    barHeight: isBoldBar ? 265 : 240,
    axiosHeight: isBoldBar ? '170px' : '145px',
  },
})

export const renderColumn = (data, property, title, mapStyle) => {
  return (
    <div className={`${bc}__column`}>
      <div className={`${bc}__title-column`}>{title}</div>
      <div className={`${bc}__avgs`} style={{ height: mapStyle[data.length].axiosHeight }}>
        {data.map((el, i) => (
          <div key={`${property}_${i}`} className={`${bc}__avg ${bc}__column-font`}>
            {el[property] === null ? NA : el[property].toFixed(1)}
          </div>
        ))}
      </div>
    </div>
  )
}

const renderLeftAxios = (data, property, isOverall, mapStyle) => {
  return (
    <div className={`${bc}__column ${bc}__column-left`}>
      <div className={`${bc}__title-column`} style={{ opacity: isOverall ? 1 : 0 }}>
        PERSPECTIVES
      </div>
      <div className={`${bc}__avgs`} style={{ height: mapStyle[data.length].axiosHeight }}>
        {data.map((el, i) => (
          <div key={`${property}_${i}`} className={`${bc}__row ${bc}__column-font`}>
            <div className={`${bc}__circle`} style={{ backgroundColor: COLORS_BY_REVIEWER_TYPE[el.reviewerType] }} />
            <div className={`${bc}__type`}>{el.reviewerType}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

const BarChart = ({
  title,
  data,
  classNameTitle,
  reviewers,
  overall,
  handleToggle,
  isOpened = true,
  isBoldBar = false,
}) => {
  const mapStyle = styleMap(isBoldBar)
  // this need for removing empty reviewersTypes
  const updatedData = data.reduce((acc, el) => {
    if (el.reviewerType === SUPERVISORS && reviewers[TYPE_OF_REVIEWERS.SUPERIOR]) {
      acc[2] = el
      return acc
    }
    if (el.reviewerType === PEERS && reviewers[TYPE_OF_REVIEWERS.PEER]) {
      acc[1] = el
      return acc
    }
    if (el.reviewerType === DIRECT && reviewers[TYPE_OF_REVIEWERS.EMPLOYEE]) {
      acc[3] = el
      return acc
    }
    if (el.reviewerType === SELF) {
      acc[0] = el
      return acc
    }
    return acc
  }, [])
  const compactedData = compact(updatedData)
  const compactedDataReversed = [...compactedData].reverse()
  const isClosed = !isOpened
  return (
    // ${bc}__closed need for safari https://app.zenhub.com/workspaces/prohabits-593f2a22b747921fa7ecc0b1/issues/prohabits/prohabits-ui/4071
    <div className={cn(bc, { [`${bc}__closed`]: isClosed })}>
      <div>
        <div className={cn(`${bc}__title-wrapper`, { [`${bc}__title-wrapper--closed`]: isClosed })}>
          <span className={cn(`${bc}__title`, { [classNameTitle]: classNameTitle })}>{title}</span>
          {overall && (
            <div className={`${bc}__overall`}>
              <div>OVERALL RATING</div>
              <div className={`${bc}__overall-number`}>{overall}</div>
              <ArrowTop className={cn(`${bc}__arrow`, { [`${bc}__arrow-bottom`]: isClosed })} onClick={handleToggle} />
            </div>
          )}
        </div>
        {!isClosed && (
          <div className={`${bc}__chart`}>
            {renderLeftAxios(compactedData, FIRST_ROW, overall, mapStyle)}
            <Bar
              layout="horizontal"
              data={compactedDataReversed}
              width={700}
              height={mapStyle[compactedDataReversed.length].barHeight}
              keys={[FIRST_ROW]}
              indexBy="reviewerType"
              margin={{ top: 30, right: 10, bottom: 25, left: 10 }}
              padding={isBoldBar ? 0.35 : 0.45}
              colors={node => {
                return COLORS_OPACITY_08[node.indexValue]
              }}
              enableGridX
              enableGridY={false}
              enableLabel={false}
              axisBottom={{
                enable: true,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
              }}
              axisLeft={null}
              animate
              motionStiffness={90}
              motionDamping={15}
              maxValue={4}
            />
            <div className={`${bc}__columns`}>
              {renderColumn(compactedData, FIRST_ROW, 'AVG', mapStyle)}
              {renderColumn(compactedData, 'teamAvg', 'TEAM', mapStyle)}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default BarChart
